module.exports = __webpack_public_path__ + "media/images/flags/bf-2bc241790e5f529501416c77cdf9e8d9.svg";